import { render, staticRenderFns } from "./DashboardEmissionBars.vue?vue&type=template&id=5cf4a098&"
import script from "./DashboardEmissionBars.vue?vue&type=script&lang=js&"
export * from "./DashboardEmissionBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports